import { Avatar, Tooltip } from 'antd';
import { Link } from 'react-router-dom';

import { isMobile } from '../../../../../../services/clientService';
import { buildUserPageUrl } from '../../../../../../services/urlBuilderService';
import { getUserImage } from '../../../../../../services/userService';

import './index.scss';

export const CollaboratorsView = (props) => {
  const { users, count, shouldDisableClick } = props;

  if (!(users?.length > 0)) return null;
  const isMobileLayout = isMobile();

  if (window.location.pathname.includes('onboarding')) return null;

  const renderAvatar = (user) => (
    <Avatar src={getUserImage(user)} alt={user.firstName} />
  );

  const maxCount = count || (isMobileLayout ? 3 : 4);

  return (
    <div className="collaborators-view">
      <Avatar.Group size="large" maxCount={maxCount}>
        {users.map((user) => (
          <Tooltip
            key={user._id}
            title={isMobileLayout ? '' : `${user.name || ''}`}
          >
            {shouldDisableClick ? (
              renderAvatar(user)
            ) : (
              <Link target="_blank" to={buildUserPageUrl(user)}>
                {renderAvatar(user)}
              </Link>
            )}
          </Tooltip>
        ))}
      </Avatar.Group>
    </div>
  );
};
